import React, { useRef, useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { textToLinks } from 'utils/text-to-links';

export const VideoDescriptionDecorated = (props) => {
  const { description } = props;

  const [shorten, setShorten] = useState(true);
  const [showButton, setShowButton] = useState();
  const videoDesc = textToLinks(description);

  const { t } = useTranslation();
  const paragraphContainer = useRef();

  useEffect(() => {
    if (description && paragraphContainer.current) {
      const links = paragraphContainer.current.querySelectorAll('a');

      links.forEach((link) => {
        if (link.target === '_blank') {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(e.target.href, '_blank');
          });
        }
      });

      const containerHeight = paragraphContainer.current.clientHeight;
      const paragraphHeight = paragraphContainer.current.childNodes[0].clientHeight;

      if (containerHeight < paragraphHeight) {
        setShowButton(true);
        setShorten(true);
      } else {
        setShowButton(false);
        setShorten(false);
      }
    }
  }, [description]);

  const toggleShowMore = () => {
    setShorten(!shorten);
  };
  const shortText = shorten ? ' ct-video-description__text--short' : '';

  return (
    <div className="ct-video-description" data-e2e={'ct-video-description'}>
      <div className={`ct-video-description__text${shortText}`} ref={paragraphContainer}>
        <p>{videoDesc}</p>
      </div>

      {showButton && (
        <div className="ct-video-description__link">
          <button type="button" className="link-button ct-video-description__show-more" onClick={toggleShowMore}>
            {shorten ? t('show_more') : t('show_less')}
          </button>
        </div>
      )}
    </div>
  );
};

VideoDescriptionDecorated.propTypes = {
  description: PropTypes.string.isRequired,
};
